@if (alertService.show) {
  <div class="alert-curtain" (click)="onCurtain()">
    <div class="alert-box" appStopPropagation>
      <h3 class="alert-title">{{ alertService.title }}</h3>
      <div class="inner-message">
        <div>{{ alertService.message }}</div>
        <div class="small-message">{{ alertService.message_small }}</div>
      </div>
      @if (alertService.type === 'YES_NO') {
        <div class="buttons">
          <button (click)="onNo()">NO</button>
          <button (click)="onYes()">YES</button>
        </div>
      }
      @if (alertService.type === 'OK_ONLY') {
        <div class="buttons">
          <button (click)="onOK()">OK</button>
        </div>
      }
    </div>
  </div>
}
